import React, { useEffect, useRef, useState } from 'react';
import {
  AppBar,
  Box,
  Checkbox,
  CircularProgress,
  Dialog,
  FormControlLabel,
  IconButton,
  Toolbar,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import request from '../../utils/request';
import { LoadingButton } from '@mui/lab';
import { useReactToPrint } from 'react-to-print';
import PrintIcon from '@mui/icons-material/Print';
import EndorsementShareModel from './EndorsementShareModel';
import SnackbarAlert from '../common/SnackbarAlert';

function EndorsementPreview({ onClose, policyData, createEndorsement, endorsementloader,showSnackBarAlert,handleSnackbarClose }) {
  const [htmlContent, setHtmlContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [shareEndorsement, setShareEndorsement] = useState(false);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [useCustomEmail, setUseCustomEmail] = useState(false);
  const [customEmail, setCustomEmail] = useState('');


  const printRef = useRef();

  const printForm = useReactToPrint({
    content: () => printRef.current,
    documentTitle: 'Endorsement Preview',
    removeAfterPrint: true
  });

  useEffect(() => {
    setLoading(true);
    setError('');
    setHtmlContent('');

    request({
      url: '/endorsement/getPolicyQcMailPreview',
      method: 'post',
      data: { policyId: policyData?.id }
    })
      .then((res) => {
        const html = res?.data || res;
        if (!html) throw new Error('Empty HTML response');
        setHtmlContent(html);
      })
      .catch(() => setError('Unable to load QC mail preview.'))
      .finally(() => setLoading(false));
  }, [policyData]);

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Dialog fullScreen open onClose={onClose}>
        <AppBar sx={{ position: 'relative', minHeight: 50, p: 1, background: '#fff', color: '#211f1f' }}>
          <Toolbar sx={{ justifyContent: 'space-between' }}>
            <Box display="flex" alignItems="center">
              <IconButton onClick={onClose}><CloseIcon /></IconButton>
              <Typography sx={{ ml: 2 }} variant="h6">Endorsement Preview</Typography>
            </Box>

            <Box display="flex" alignItems="center" gap={2}>
              <Box display="flex" alignItems="center" gap={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={shareEndorsement}
                      onChange={(e) => setShareEndorsement(e.target.checked)}
                    />
                  }
                  label="Share Endorsement"
                />

                <IconButton onClick={printForm}>
                  <PrintIcon />
                </IconButton>

                <LoadingButton
                  loading={endorsementloader}
                  variant="contained"
                  color="warning"
                  onClick={() => {
                    if (shareEndorsement) setShareDialogOpen(true);
                    else createEndorsement('Endorsement');
                  }}
                  sx={{ textTransform: 'none', fontWeight: 600, boxShadow: 'none' }}
                >
                  Create Endorsement
                </LoadingButton>
              </Box>

            </Box>
          </Toolbar>
        </AppBar>

        <Box sx={{ height: '100%', width: '100%', overflow: 'auto' }}>
          {loading && <Box height="100%" display="flex" alignItems="center" justifyContent="center"><CircularProgress /></Box>}
          {error && <Box height="100%" display="flex" alignItems="center" justifyContent="center"><Typography color="error">{error}</Typography></Box>}
          {htmlContent && !loading && (
            <iframe
              title="QC Mail HTML Preview"
              srcDoc={htmlContent}
              style={{ border: 'none', width: '100%', height: '100%' }}
            />
          )}
        </Box>
      </Dialog>
      {shareDialogOpen && <EndorsementShareModel setShareDialogOpen={setShareDialogOpen} setCustomEmail={setCustomEmail}
        customEmail={customEmail} createEndorsement={createEndorsement} endorsementloader={endorsementloader}
        policyData={policyData} />}


      {/* PRINT ROOT */}
      <Box
        id="print-root"
        ref={printRef}
        sx={{
          display: 'none',
          width: '210mm',
          minHeight: '297mm',
          padding: '20mm'
        }}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />

      <style>
        {`
          @media print {
            body { overflow: hidden !important; }

            body * { visibility: hidden; }

            #print-root, #print-root * {
              visibility: visible;
            }

            #print-root {
              display: block !important;
              overflow: visible !important;
            }

            * { scrollbar-width: none !important; }
            *::-webkit-scrollbar { display: none !important; }
          }
        `}
      </style>
    </>
  );
}

export default EndorsementPreview;
